import type { IGalleryPhoto } from '../constants/sensorGalleryType';

const getNameplatesWithoutInstallationPoints = (images: IGalleryPhoto[]) => {
  const nameplates = images.filter((image) => {
    if (image.imageType === 'nameplatePhoto' && !image.installationPoint?.length) return true;
    return false;
  });
  
  return nameplates;
};

export default getNameplatesWithoutInstallationPoints;
